const initState='';

const SidebarList = (state = initState, action) => {
    switch(action.type) {
        case  'MainTabContentTabList' : return  action.payload;
        default: return state;
    }
}
export default SidebarList;